import * as React from 'react'
import { observer } from 'mobx-react'
import LocalizationStore from '../../../../Stores/LocalizationStore'
import { Button } from 'react-bootstrap'
import { history } from '../../../../Routing'
import Form, { ISubmitEvent } from 'react-jsonschema-form'

export interface IGetExternalDataByCreditNumberFormProps {
    localizationStore?: LocalizationStore,
    className?: string
}

@observer
export default class SearchPage 
        extends React.Component<IGetExternalDataByCreditNumberFormProps> {
    
            constructor(props: any) {
        super(props)
    }

    schema: Object = {
        'type': 'object',
        'properties': {
            'creditNumber': {
                'title': LocalizationStore.getInstance().t('Enter credit number'),
                'type': 'string'
            }
        }
    }

    submit(e: ISubmitEvent<any>) {
        history.push('/externalData/searchByCreditNumber/' + e.formData['creditNumber'])
    }

    render() {
        const self = this
        let ls = LocalizationStore.getInstance()

        return (
            <div className="searchBlock">
                <Form
                    onSubmit={(e) => self.submit(e)}
                    schema={self.schema}
                >
                    <div className="searchBtn">
                        <Button type="submit">{ls.t!('SearchBtn')}</Button>
                    </div>  
                </Form>
            </div>
            
        )
    }
}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/Views/PartialViews/ExternalData/ExternalDataSearchViews/ExternalDataSearchByCreditNumberView.tsx